// src/routes/routes-loader.tsx
import { lazy, Suspense as ReactSuspense } from "react";
import LoadingScreen from "../components/LoadingScreen";

const Suspense: any = ReactSuspense;

const Loadable = (Component: any) => (props: any) => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
};

const RouteLazyLoader = {
  // Authentication
  Login: Loadable(lazy(() => import("../pages/Authentication/Login"))),
  Register: Loadable(lazy(() => import("../pages/Authentication/Register"))),
  ForgotPassword: Loadable(lazy(() => import("../pages/Authentication/ForgotPassword"))),
  ResetPassword: Loadable(lazy(() => import("../pages/Authentication/ResetPassword"))),

  // Dashboard
  Dashboard: Loadable(lazy(() => import("../pages/Dashboard/Dashboard"))),

  // Profile
  Profile: Loadable(lazy(() => import("../pages/Profile/Profile"))),

  // Parishes
  ParishesList: Loadable(lazy(() => import("../pages/Parishes/ParishesList"))),
  ParishDetails: Loadable(lazy(() => import("../pages/Parishes/ParishDetails"))),
  ParishStatistics: Loadable(lazy(() => import("../pages/Parishes/ParishStatistics"))),
  CoordinatorsList: Loadable(lazy(() => import("../pages/Parishes/CoordinatorsList"))),

  // Schools
  SchoolsList: Loadable(lazy(() => import("../pages/Schools/SchoolsList"))),
  SchoolDetails: Loadable(lazy(() => import("../pages/Schools/SchoolDetails"))),
  SchoolStatistics: Loadable(lazy(() => import("../pages/Schools/SchoolStatistics"))),
  MySchool: Loadable(lazy(() => import("../pages/Schools/MySchool"))),
  SchoolPerformance: Loadable(lazy(() => import("../pages/Schools/SchoolPerformance"))),

  // Meetings
  MeetingsList: Loadable(lazy(() => import("../pages/Meetings/Meeting"))),
  MeetingDetails: Loadable(lazy(() => import("../pages/Meetings/MeetingDetails"))),
  MeetingForm: Loadable(lazy(() => import("../pages/Meetings/MeetingForm"))),

  // Assessments - Enhanced// This is the DETAILS component
  AssessmentsList: Loadable(lazy(() => import("../pages/Assessments/Assessment"))),
  AssessmentDetails: Loadable(lazy(() => import("../pages/Assessments/AssessmentDetails"))),
  AssessmentForm: Loadable(lazy(() => import("../pages/Assessments/AssessmentForm"))),
  IndicatorsList: Loadable(lazy(() => import("../pages/Assessments/Indicators"))),
  IndicatorManagement: Loadable(lazy(() => import("../pages/Assessments/IndicatorManagement"))),
  OutcomeAreaManagement: Loadable(lazy(() => import("../pages/Assessments/OutcomeAreaManagement"))),
  ChampionSchools: Loadable(lazy(() => import("../pages/Assessments/ChampionSchools"))),

  // Admin - Users
  UsersList: Loadable(lazy(() => import("../pages/Admin/Users/Users"))),
  UserDetails: Loadable(lazy(() => import("../pages/Admin/Users/UserDetails"))),
  
  // Admin - Roles
  RolesList: Loadable(lazy(() => import("../pages/Admin/Roles/Roles"))),
  
  // Admin - Settings
  SystemSettings: Loadable(lazy(() => import("../pages/Admin/Settings/SystemSettings"))),
  
  // Admin - Audit Logs
  AuditLogs: Loadable(lazy(() => import("../pages/Admin/Audit/AuditLogs"))),

  // Training
  TrainingModules: Loadable(lazy(() => import("../pages/Training/TrainingModules"))),
  TrainingModuleDetails: Loadable(lazy(() => import("../pages/Training/TrainingModuleDetails"))),
  TrainingSessions: Loadable(lazy(() => import("../pages/Training/TrainingSessions"))),
  MyProgress: Loadable(lazy(() => import("../pages/Training/MyProgress"))),
  TrainingManage: Loadable(lazy(() => import("../pages/Training/TrainingManage"))),
  TrainingResources: Loadable(lazy(() => import("../pages/Training/TrainingResources"))),

  // PLC
  PLCList: Loadable(lazy(() => import("../pages/PLC/PLCList"))),
  PLCDetails: Loadable(lazy(() => import("../pages/PLC/PLCDetails"))),

  // Reports
  Reports: Loadable(lazy(() => import("../pages/Reports/Reports"))),

  // Financials
  Subscriptions: Loadable(lazy(() => import("../pages/Financials/Subscriptions"))),

  // Help
  UserGuide: Loadable(lazy(() => import("../pages/Guide/UserGuide"))),
  TestingGuide: Loadable(lazy(() => import("../pages/Guide/TestingGuide"))),

  // Error Pages
  Error404: Loadable(lazy(() => import("../pages/404"))),
  Error403: Loadable(lazy(() => import("../pages/403"))),
};

export default RouteLazyLoader;